import papi from '@k4connect/project-camelot-ui-library-papi/papi';
import http from '@k4connect/project-camelot-ui-library-papi/http';
import env from '@k4connect/project-camelot-ui-library-papi/env';

export default {

	papi,

	navigation: {
		setLoading(key, value)
		{
			//store.dispatch('navigation/loading', { [key]: value })
		}
	},

	alerts: {
		setWarning(text)
		{
			//store.dispatch('alerts/warning', text)
		},
		setError(text)
		{
			//store.dispatch('alerts/error', text)
		}
	},

	theme: {
		get getDark()
		{
			return false;
		}
	},

	strings: {
		errors: {
			generic: 'Something went wrong'
		}
	},

	login()
	{
		return '/login'
	},

	async init(jwt)
	{
		console.log('Camelot init...');
		this.jwt = jwt;

		env.login = this.login;
		env.logout = this.login;
		http.init(this.navigation, this.alerts, this.strings);
		await papi.init(this.jwt, env);
	}
}